export const PAGE_SIZE = 32

export const ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES = {
  owner: "grow",
  quantity: "w-[160px] justify-end",
}
